import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgxErrorsModule } from "@ultimate/ngxerrors";
import { TextMaskModule } from "angular2-text-mask";
import { ComponentModule } from "../components/component.module";
import { UserService } from "../core/service/user.service";
import { SMCourseService } from "../shell/forms/academic/CourseAndBatch/SM-Course/smcourse.service";
import { FOAdmEnquiryService } from "../shell/forms/front-office/admissionenquiry/admissionenquiry.service";
import { CityService } from "../shell/forms/organizational-setup/setup/City/City.service";
import { CountryService } from "../shell/forms/organizational-setup/setup/Country/Country.service";
import { InstituteService } from "../shell/forms/organizational-setup/setup/institute/institute.service";
import { StateService } from "../shell/forms/organizational-setup/setup/State/State.service";
import { RelationTypeService } from "../shell/shared/relationtype.service";
import { AdmisformComponent } from "./admisform.component";
import { AdmissionFormService } from "./admisformservice";
// import { AdmissionFormRoutingModule } from "./admission.routing.module";




@NgModule({

    imports: 
    [ 
        CommonModule,
        FormsModule,
        ComponentModule,
        ReactiveFormsModule,
        NgxErrorsModule,
        // AdmissionFormRoutingModule,
        TextMaskModule,
    ],  
    
    exports:
    [ 
        AdmisformComponent
    ],
    
    declarations: 
     [
        AdmisformComponent
     ],
    
    providers: 
    [
        InstituteService,
        CountryService,
        CityService,
        StateService,
        AdmissionFormService,
        RelationTypeService,
        SMCourseService,
        UserService,
        FOAdmEnquiryService,
        
    ]
  })
  export class AdmissionFormModule {}


// WEBPACK FOOTER //
// ./src/app/admisform/admisform.module.ts